<template>
  <div class="exhibitions-content flex fd-c">
    <div class="item" v-for="(item, index) in list" :key="index">
      <div class="title-box flex fd-c listWOW fadeInDown" data-wow-duration="0.5s" data-wow-delay="0.2s" v-html="item.info"></div>
      <div class="list">
        <div class="list-item" v-for="(im, ix) in item.works" :key="ix">
          <img 
            :src="im.pictures" 
            class="list-item-img listWOW fadeInDown" 
            @click="picturesClick(item, ix)" 
            data-wow-duration="0.5s" 
            data-wow-delay="0.4s" alt="">
          <div class="list-item-title listWOW fadeInDown" data-wow-duration="0.5s" data-wow-delay="0.6s" v-html="im.info"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { findExhibitions } from '../../api'
import { ImagePreview } from 'vant';
import { WOW } from "wowjs";
export default {
  components:{},
  props:{},
  data(){
    return {
      list: [],
    }
  },
  watch:{},
  computed:{},
  methods:{
    findExhibitions() {
          findExhibitions({
            page: 1,
            limit: 100,
          }).then(res=>{
              this.list = res.data.data.records
              this.$nextTick(()=>{
                  this.listWOW()
              })
          })
      },
      listWOW () {
        var wow = new WOW({
            boxClass: "listWOW",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true
        });
        wow.init();
     },
     picturesClick(item, index){
       console.log(item);
       var imagePreviewList = []
       for (var im of item.works) {
         imagePreviewList.push(im.pictures)
       }
       ImagePreview({
        images: imagePreviewList,
        startPosition: index,
      })
     }
  },
  created(){
    this.findExhibitions()
  },
  mounted(){}
}
</script>
<style scoped>
.exhibitions-content{
    padding-top:.6rem;
}
.item+.item{
    margin-top:.7rem;
}
.title-box>>>span,
.title-box>>>p{
  font-size: .2rem!important;
  font-weight: 400!important;
  color: #0071BC!important;
  line-height: 1.1!important;
}
.list-item+.list-item{
    margin-top:.7rem;
}
.list-item-img{
  display: block;
  width: 100%;
  height: auto;
  margin-top: .2rem;
}
.list-item-title {
  margin-top: .2rem;
}
.list-item-title>>>p{
  font-size: .2rem!important;
    font-family: Khmer Sangam MN;
    font-weight: 400!important;
    color: #000000!important;
    line-height: 1.2!important;
}
.list-item-title>>>span{
    font-size: .2rem!important;
    font-family: Khmer Sangam MN;
    font-weight: 400!important;
    color: #000000!important;
    line-height: 1.2!important;
}
</style>